import { render, staticRenderFns } from "./addTransport.vue?vue&type=template&id=9ba7051a&scoped=true&"
import script from "./addTransport.vue?vue&type=script&lang=js&"
export * from "./addTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba7051a",
  null
  
)

export default component.exports